<mat-card appearance="outlined">
  <mat-card-header>
    <mat-icon mat-card-avatar class="email"></mat-icon>
    <mat-card-title class="card-title">{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.TITLE' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="statement">{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.DESCRIPTION' | translate }}</div>
  </mat-card-content>
</mat-card>
